var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1,13C7,13,7,6,9.6,6s2.6,11,3.5,11s0.9-7,3.5-7s1.8,5,2.6,5s0.9-3,2.6-3c0.7,0,4,0,5.5,0 c0.4-1.1,0.7-2.3,0.7-3.5C28,3.8,24.7,0,20.6,0c-2.8,0-5.3,1.8-6.6,4.5C12.7,1.8,10.3,0,7.4,0C3.3,0,0,3.8,0,8.5 c0,1.7,0.4,3.2,1.1,4.5H6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,14h-3.5c-1.8,0-1.8,3-3.5,3c-2.6,0-1.8-5-2.6-5s-0.9,8-3.5,8S10.5,9,9.6,9S8.7,15,7,15H2.6 c0,0,9.5,11.6,10.1,12.4c0.7,0.8,1.8,0.8,2.5,0C15.9,26.6,25.4,15,25.4,15l0,0C25.7,14.7,26,14.4,26.2,14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthWarningIcon);
export default __webpack_public_path__ + "static/media/health-warning-icon.d3d091e5798f6a962b04e0e91be29a94.svg";
export { ForwardRef as ReactComponent };